import * as actions from "./actionTypes";

const initialState = {
  schools: [],
  selectedSchool: null,
  paymentOptionsForSchool: [],
  ratingParams: [],
  schoolRatings: [],
  loadSuccess: false,
};

const school = (state = initialState, action) => {
  switch (action.type) {
   
    case actions.UPDATE_SCHOOL:
      var schools = [...state.schools];
      var temp = state.schools.filter(
        (school) => school.id === action.payload.school.id
      );
      if (temp.length > 0) {
        var index = schools.indexOf(temp[0]);
        schools[index] = action.payload.school;
        if (
          state.selectedSchool &&
          state.selectedSchool.id === action.payload.school.id
        ) {
          state = {
            ...state,
            schools: schools,
            selectedSchool: action.payload.school,
          };
        } else {
          state = { ...state, schools: schools };
        }
      } else {
        schools.push(action.payload.school);
        if (
          state.selectedSchool &&
          state.selectedSchool.id === action.payload.school.id
        ) {
          state = {
            ...state,
            schools: schools,
            selectedSchool: action.payload.school,
          };
        } else {
          state = { ...state, schools: schools };
        }
      }
      break;
    case actions.UPDATE_SCHOOLS:
      state = { ...state, schools: action.payload.schools };
      break;

    case actions.UPDATE_PAYMENT_OPTIONS:
      state = {
        ...state,
        paymentOptionsForSchool: action.payload.paymentOptionsForSchool,
      };
      break;
    case actions.DELETE_SCHOOL:
      var schools = state.schools.filter(
        (school) => school.id !== action.payload.id
      );
      state = { ...state, schools: schools };
      break;
    case actions.UPDATE_SELECTED_SCHOOL:
      state = { ...state, selectedSchool: action.payload.school };
      break;

    ////School Ratings
    case actions.UPDATE_RATING_PARAMS:
      state = { ...state, ratingParams: action.payload.ratingParams };
      break;

    case actions.UPDATE_SCHOOL_RATINGS:
      var schoolRatings = [...state.schoolRatings];
      if (schoolRatings.length > 0) {
        for (const latest in action.payload.schoolRatings) {
          var temp = schoolRatings.filter(
            (schoolRating) =>
              schoolRating.id === action.payload.schoolRatings[latest].id
          );
          if (temp.length > 0) {
            var index = schoolRatings.lastIndexOf(temp[0]);
            schoolRatings[index] = action.payload.schoolRatings[latest];
          } else {
            schoolRatings.push(action.payload.schoolRatings[latest]);
          }
        }
        state = { ...state, schoolRatings: schoolRatings };
      } else {
        state = { ...state, schoolRatings: action.payload.schoolRatings };
      }

      break;
    case actions.SET_ALL_SCHOOLS_FOR_INSTITUTE:
      state = { ...state, schools: action.payload.schoolObjs };
      break;
    case actions.SET_FRANCHISE_DETAILS:
      state = { ...state, franchise: action.payload.obj, loadSuccess: true };
      break;
    case actions.SET_ALL_SCHOOL_DETAILS_FOR_FRANCHISE:
      state = { ...state, schools: action.payload.schoolObjs };
      break;
    case actions.SET_INSTITUTE_DETAILS_FOR_ID:
      state = { ...state, institute: action.payload.instituteObj };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default school;
